import { createAction, props } from '@ngrx/store';
import { DataStartedAt, DataWorkshopEntity } from '@edgvr-front/data/domain';
import { WorkshopName } from '@edgvr-front/workshops/domain';

export const init = createAction('[Data Workshop / Workshops List Page] Init');
export const destroy = createAction(
  '[Data Workshop / Workshops List Page] Destroy'
);

export const dataWorkshopsList = createAction(
  '[Data Workshop / Workshops List Page] Data Workshops List',
  props<{
    page: number;
    workshopName?: WorkshopName;
    from?: DataStartedAt;
    to?: DataStartedAt;
  }>()
);
export const dataWorkshopsListSuccess = createAction(
  '[Data Workshop / Workshops List Page] Data Workshops List Success',
  props<{ dataWorkshops: DataWorkshopEntity[]; count: number; page: number }>()
);
export const dataWorkshopsListFailure = createAction(
  '[Data Workshop / Workshops List Page] Data Workshops List Failure'
);
